var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAudienceIconExpanded = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 29v1H2V29a3.992 3.992 0 012.35-3.635 2.5 2.5 0 113.3 0A3.992 3.992 0 0110 29zM20 29v1H12V29a3.992 3.992 0 012.35-3.635 2.5 2.5 0 113.3 0A3.992 3.992 0 0120 29zM30 29v1H22V29a3.992 3.992 0 012.35-3.635 2.5 2.5 0 113.3 0A3.992 3.992 0 0130 29z",
    fill: "#76fd7d",
    transform: "translate(-2 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 2",
    d: "M4981.5-739a.5.5,0,0,1-.5-.5v-16a.5.5,0,0,1,.5-.5h27a.5.5,0,0,1,.5.5v16a.5.5,0,0,1-.5.5Z",
    transform: "translate(-4981 756)",
    fill: "#d8ffda"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAudienceIconExpanded);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AudienceIconExpanded.6579de862cc139d3792a0ce31fabd6fd.svg";